import {clearSkillPathCache} from '../SkillPath/hooks/useStudentSkillPath';
import isWelcomeRoute from '../isWelcomeRoute';
import useClassroomInvitations from '../ClassroomInvitations/hooks/useClassroomInvitations';
import useClassrooms from '../Sidebar/hooks/useClassrooms';
import useCurrentTab from './useCurrentTab';
import useIndependentPracticeSubjects, {
  invalidateIndependentPracticeSubjectsCache
} from '../IndependentPractice/hooks/useIndependentPracticeSubjects';
import useSyncDefaultRoute from './useSyncDefaultRoute';

export default function useOnClassroomEnrollment() {
  const {pathname} = window.location;

  const currentTab = useCurrentTab();
  const {fetchClassroomInvitations} = useClassroomInvitations();
  const {fetchClassrooms} = useClassrooms();
  const {fetchIndependentPracticeSubjects} = useIndependentPracticeSubjects();
  const {syncDefaultRoute} = useSyncDefaultRoute();

  function onClassroomEnrollment(classroomId: string | undefined) {
    clearSkillPathCache();
    // Enrollment changes which subjects the student can access, so drop the cached
    // scope-less "all subjects" list (always) and the current route scope. Passing the
    // route scope id — not the newly-enrolled classroom's — is intentional: that
    // classroom's own scoped list was never fetched while access was denied, so it has
    // no stale entry to clear.
    invalidateIndependentPracticeSubjectsCache(classroomId);
    fetchClassroomInvitations();
    fetchClassrooms();

    if (currentTab === 'independent-practice') {
      fetchIndependentPracticeSubjects(classroomId);
    }

    syncDefaultRoute(classroomId, pathname, !isWelcomeRoute(pathname));
  }

  return onClassroomEnrollment;
}
